import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";
import { getLineItemTreatedByMerchantQuantity } from "./get-line-item-treated-by-merchant-quantity";

type UseLineItemValidatedMaxQuantityParams = {
  lineItem: ReturnRequestLineItemDto;
};

/**
 * Returns the maximum quantity that a merchant can treat when workflow logistician is NOT activated.
 *
 * The calculation is:
 * - Takes the original purchased quantity
 * - Subtracts quantity already treated by merchant
 * - Returns remaining untreated quantity eligible for merchant treatment
 *
 * @example
 * If a line item was purchased 4 times:
 * - Merchant treated 1 item
 * - Result: 3 items remaining that can be treated by merchant (4 - 1 = 3)
 */
export function getLineItemReadyToBeTreatedByMerchantSelectableQuantityWithoutWorkflowLogistician({
  lineItem,
}: UseLineItemValidatedMaxQuantityParams) {
  const quantityTreatedByMerchant = getLineItemTreatedByMerchantQuantity({
    lineItem,
  });

  return Math.max(lineItem.quantity - quantityTreatedByMerchant, 0);
}
